module.exports = __webpack_public_path__ + "img/J12325.0d09d83a.png";